module.exports = __webpack_public_path__ + "static/media/laravel.92d43935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/laravel.png
// module id = 123
// module chunks = 0